module.exports = __webpack_public_path__ + "img/phone-icon.1b8e73c0.svg";